(function (w, $) {

    const assetId = '~/Parts/Views/Menu/MegaMenu.min.js';

    if (!w.umwAssets || !w.umwAssets[assetId]) {
        console.error('No context found for ' + assetId);
        return;
    }

    for (let ctx of w.umwAssets[assetId]) {

        const prefixClass = ctx.controlId.toLowerCase();

        const classes = {
            control: "js-" + prefixClass,
            lvl1Item: "js-" + prefixClass + "-lvl1-item",
            lvl1ItemHovered: prefixClass + "-lvl1__item_hovered",
        };

        const beforeMegaMenuLvl1Mouseenter = new $.Event("megamenu:lvl1:beforemouseenter");
        const beforeMegaMenuLvl1Mouseleave = new $.Event("megamenu:lvl1:beforemouseleave");

        const $control = $("." + classes.control);
        const $lvl1Item = $("." + classes.lvl1Item, $control);
        const hoverDelay = 250;
        let hoverTimerId;

        $control.on("mouseenter", "." + classes.lvl1Item, function(e) {

            $control.trigger(beforeMegaMenuLvl1Mouseenter, [hoverTimerId, hoverDelay]);

            if (beforeMegaMenuLvl1Mouseenter.isDefaultPrevented()) {
                return;
            }

            clearInterval(hoverTimerId);

            hoverTimerId = setTimeout(function() {
                    $lvl1Item.removeClass(classes.lvl1ItemHovered);
                    $(e.currentTarget).addClass(classes.lvl1ItemHovered);
                },
                hoverDelay);
        });

        $control.on("mouseleave", "." + classes.lvl1Item, function(e) {

            $control.trigger(beforeMegaMenuLvl1Mouseleave, [hoverTimerId, hoverDelay]);

            if (beforeMegaMenuLvl1Mouseleave.isDefaultPrevented()) {
                return;
            }

            clearInterval(hoverTimerId);

            hoverTimerId = setTimeout(function () {
                    $lvl1Item.removeClass(classes.lvl1ItemHovered);
                },
                hoverDelay);
        });
    }

})(window, jQuery);